import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import { useBestInTravel } from "@context/bestInTravel/2025/bestInTravelContext";
import { keyify } from "@utils/keyify";

const Player = dynamic(() => import("@jwplayer/jwplayer-react"), {
  ssr: false,
});

export function Video({ data }) {
  const { screen } = useBestInTravel();
  const { vid, destinationName } = data;
  const shareLink = `https://www.lonelyplanet.com/best-in-travel${destinationName ? `#${keyify(destinationName)}` : ""}`;
  const pid = screen === "sm" ? "pxrKna5G" : "Bc6knAOw";

  return (
    <Player
      key={vid}
      library={`https://cdn.jwplayer.com/libraries/${pid}.js`}
      config={{
        autostart: true,
        file: `https://content.jwplatform.com/manifests/${vid}.m3u8`,
      }}
      sharing={{
        link: shareLink,
      }}
    />
  );
}

Video.propTypes = {
  data: PropTypes.shape({
    vid: PropTypes.string.isRequired,
    destinationName: PropTypes.string.isRequired,
  }).isRequired,
};
